import { render, staticRenderFns } from "./StorePolicy.vue?vue&type=template&id=71807606&scoped=true"
import script from "./StorePolicy.vue?vue&type=script&lang=js"
export * from "./StorePolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71807606",
  null
  
)

export default component.exports